import {
  PAGINATION_KEY
} from "../../const";

export default class BrowserNavigation {
  constructor(changeFilter) {
    this._observers = [];
    this._changeFilter = changeFilter;

    this._handleWindowPopstate = this._handleWindowPopstate.bind(this);

    this._init();
  }

  addObserver(observer) {
    this._observers.push(observer);
  }

  removeObserver(observer) {
    this._observers = this._observers.filter((existedObserver) => existedObserver !== observer);
  }

  _init() {
    window.addEventListener(`popstate`, this._handleWindowPopstate);
  }

  _notify(data) {
    const options = {
      preventUrlChange: true
    };

    const pageItem = data.find((item) => item.name === PAGINATION_KEY);

    if (pageItem) {
      options.page = +pageItem.values;
    }

    this._observers.forEach((observer) => observer(data));
    this._changeFilter.updateProductsData(options);
  }

  _prepareState(state) {
    return state
      .map((item) => {
        item = item.split(`=`);

        return {
          name: item[0],
          values: item[1]
        };
      });
  }

  _handleWindowPopstate(evt) {
    if (!evt.state) {
      document.location.reload();
      return;
    }

    if (`scrollRestoration` in history) {
      history.scrollRestoration = `manual`;
    }

    const state = this._prepareState(evt.state);

    this._notify(state);
  }
}
